const BASE_URL = `${window.location.origin}`;
// const BASE_URL = `http://localhost:8000`;

const GR_EMAIL = "gr.permaculture@gmail.com";
const GUIDE_EMAIL = "gr.permaculture@gmail.com";

module.exports = { BASE_URL, GR_EMAIL, GUIDE_EMAIL };
